




















































import { Component, Watch, Vue } from 'vue-property-decorator';
import DealerInquiry from '../components/auth/DealerInquiry.vue';
import dealers from '../server/init';
import { TrinityRingsSpinner } from 'epic-spinners';
import axios from 'axios';
import {} from 'google-maps';

@Component({
  components: {
    DealerInquiry,
    TrinityRingsSpinner,
  },
})
export default class Locations extends Vue {
  locationsLoading: boolean = true;
  searchError: string | null = null;
  address: string | null = null;
  spinner: boolean = false;
  dealers: Array<any> = [];
  lat: number = 33.6986112;
  lng: number = -117.738700799;
  markers: Array<any> = [];
  activeIndex: number = -1;
  dealerId: string = '';
  sheetOpen: boolean = false;
  formOpen: boolean = false;
  private screenSize: number = screen.width;

  $refs: {
    autocomplete: HTMLInputElement,
  }

  closeForm() {
    this.formOpen = false;
  }

  openForm() {
    this.formOpen = true;
  }


  locatorButtonPressed() {
    this.spinner = true;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.getAddressFrom(position.coords.latitude, position.coords.longitude);
          this.showUserLocation(position.coords.latitude, position.coords.longitude);
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
        },
        (error) => {
          this.searchError = 'Geolocation is unavailable, please enter your address.';
          this.spinner = false;
        }
      );
    } else {
      this.searchError = 'Your browser does not support geolocation';
      this.spinner = false;
    }
  }

  getAddressFrom(lat: number, long: number) {
    const res = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=AIzaSyD7Zf02g4WeaGlggzvd9hme0iehGiro6Wg`;
    axios.get(res).then((response) => {
      if (response.data.error_message) {
        this.searchError = response.data.error_message;
      } else {
        this.address = response.data.results[0].formatted_address;
        this.spinner = false;
      }
    })
    .catch((error) => {
      this.searchError = error.message;
      this.spinner = false;
    });
  }

  showUserLocation(lat: number, long: number) {
    this.locationsLoading = true;
    const map = new google.maps.Map(
      this.$refs['g-map'],
      {
        zoom: 15,
        center: new google.maps.LatLng(lat, long),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      });

    const infoWindow = new google.maps.InfoWindow();
    const promises = [];
      for (let i = 0; i < this.dealers.length; i++) {
        const dealerLat = this.dealers[i].lat;
        const dealerLng = this.dealers[i].lng;
        const name = this.dealers[i].company;
        const address = this.dealers[i].address;
        const city = this.dealers[i].city;
        const state = this.dealers[i].state;
        const phone = this.dealers[i].phone;
        const userLat = lat;
        const userLng = long;
        let distance = '';
        let duration = '';
        let value = 0;
        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(dealerLat, dealerLng),
          map: map,
        });

        this.markers.push(marker);
        // TODO Remove Cors anywhere header
        const req = `https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/distancematrix/json?origins=${userLat},${userLng}&destinations=${dealerLat},${dealerLng}&key=AIzaSyD7Zf02g4WeaGlggzvd9hme0iehGiro6Wg`;

        const promise = axios.get(req);
        promises.push(promise);
        promise.then((response) => {
          if (response.data.error_message) {
            this.searchError = response.data.error_message;
          } else {
            const elements = response.data.rows[0].elements;
            if (elements[0].status === 'ZERO_RESULTS') {
              this.searchError = 'No Results Found';
            } else {
              // console.log(response.data);
              distance = (elements[0].distance.text);
              duration = (elements[0].duration.text);
              value = (elements[0].distance.value);
              this.locationsLoading = false;
              this.dealers[i].distance = distance;
              this.dealers[i].duration = duration;
              this.dealers[i].value = value;
            }

          }
        })
        .catch((error) => {
          this.searchError = error.message;
        });

        google.maps.event.addListener(marker, 'click', function() {
          infoWindow.setContent(`<div class="marker-window"><h4>${name}</h4><h5>${address}, ${city}, ${state}</h5><h6><a href="tel:${phone}">${phone}</a><span>${distance} ${duration}</span></h6></div>`);
          infoWindow.open(map, marker);
        });
      }
      Promise.all(promises).then(() => {
        this.dealers.sort(function(a, b) {
          return a.value - b.value;
        });
      });
    }

  displayMarkers(){
    this.markers = [];
    const map = new google.maps.Map(
        this.$refs['g-map'],
        {
          zoom: 10,
          center: new google.maps.LatLng(this.lat, this.lng),
          mapTypeId: google.maps.MapTypeId.ROADMAP,
        }
    );
    const infoWindow = new google.maps.InfoWindow();
    for (let i = 0; i < this.dealers.length; i++) {
      const lat = this.dealers[i].lat;
      const lng = this.dealers[i].lng;
      const name = this.dealers[i].company;
      const address = this.dealers[i].address;
      const city = this.dealers[i].city;
      const state = this.dealers[i].state;
      const phone = this.dealers[i].phone;
      const userAdress = this.address;
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        map: map,
      });

      this.markers.push(marker);

      google.maps.event.addListener(marker, 'click', function() {
        infoWindow.setContent(`<div class="marker-window"><h4>${name}</h4><h5>${address}, ${city}, ${state}</h5><h6><a href="tel:${phone}">${phone}</a></h6></div>`);
        infoWindow.open(map, marker);
      });
    }
  }

  toggleSheet() {
    this.sheetOpen = !this.sheetOpen;
  }


  showInfo(index) {
    this.activeIndex = index;
    google.maps.event.trigger(this.markers[index], 'click');
  }

  mounted() {
    const autoComplete = new google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      {
        bounds: new google.maps.LatLngBounds(
          new google.maps.LatLng(36.778259, -119.417931)
        ),
      });

      autoComplete.addListener('place_changed', () => {
        const place = autoComplete.getPlace();
        this.showUserLocation(place.geometry.location.lat(), place.geometry.location.lng());
        this.address = place.formatted_address;
      });

      if (this.screenSize > 599) {
        this.sheetOpen = true;
      }
    }

  created() {
    dealers.collection('dealers').get()
    .then((snapshot) => {
      snapshot.forEach((doc) => {
        const dealer = doc.data();
        this.dealerId = doc.id;
        if ( !dealer.pending && dealer.published) {
          const x = dealer.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
          dealer.phone = '('+x[1]+')' + x[2] + '-' +x[3];
          this.dealers.push(dealer);
          this.locationsLoading = false;
          if (this.dealers.length) {
            this.displayMarkers();
          }
        }
      });
    });
  }

  @Watch('screenSize')
    private onchange(val: number, oldVal: number) {
    this.screenSize = val;
  }
}
